exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".color-panel-popover{background-color:rgba(0,0,0,.5)!important}", ""]);

// exports
